import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useFormContext } from "react-hook-form";
import Greeting from '../../../views/popups/mlib/Greeting';
import AudioPlayer from '../../mediaplayers/AudioPlayer';
import PopupLoader from '../../../views/popups/PopupLoader';

function AAVoicemails({aagcode, greetingsInfo, voicemailEAddress }) {
 const { t, i18n } = useTranslation();
   const [enableEmails, setEnableEmails] = useState(true);
   const navigate = useNavigate();
   const [unavailGreeting, setUnavailGreeting] = useState(false);
   const { busy, unavailable } = greetingsInfo ?? {};
 
   const {
     register,
     formState: { errors },
     setValue,
     getValues,
     watch,
     clearErrors
   } = useFormContext();
 
   useEffect(() => {
     if (getValues("voice_mail.email_notify") === true) {
       setEnableEmails(true);
     } else {
       setEnableEmails(false);
     }
   }, [getValues("voice_mail.email_notify")]);
 
   function handleCheckBox() {
     const toggcheckboxDiv = document.getElementById("hgemailnotify");
     setValue(
       "voice_mail.inc_user_sup",
       toggcheckboxDiv.checked ? true : false,
       {
         shouldDirty: true,
       }
     );
   }
 
   const vmGreetingEnable = () => {
     setUnavailGreeting(!unavailGreeting);
   };
 
   return (
     <>
       <div className="general-settings">{t("Voicemail")}</div>
       <div className="margin-top mb__scroll__voicmain">
         <div className="add-numbermain">
           <div className="tel-numbers">{t("Pin")}</div>
           <div className="d-flex w-30">
             <div className="phoneselect w-100">
               <input
                 onKeyPress={(event) => {
                   if (!/[0-9]/.test(event.key)) {
                     event.stopPropagation();
                     event.preventDefault();
                   }
                 }}
                 {...register("voice_mail.vm_pin", {
                   setValueAs: (value) => Number(value),
                   pattern: {
                     value: "[0-9]*",
                     message: "Must be numeric",
                   },
                 })}
                 className="w-100 form-control"
               />
               {errors.voice_mail?.vm_pin && (
                 <p className="text-danger">
                   {errors.voice_mail?.vm_pin?.message}
                 </p>
               )}
             </div>
           </div>
         </div>
 
         <div className="add-numbermain add-numbermain-small align-items-start">
           <div>
             <div className="tel-numbers">{t("unavaliableGreeting")}</div>
           </div>
           <AudioPlayer
             uniqueId={aagcode}
             greetingType={unavailable?.greeting_type ?? 1}
             greetingId={unavailable?.greeting_id ?? 0}
             fileName={unavailable?.filename ?? ""}
             title={t("VoicemailUnavailableGreeting")}
             greetingMode={unavailable?.filename ?? "" !== "" ? 1 : 2}
             greetingTitle = {unavailable?.title ?? ""}
             greetingObject = {unavailable ?? null}
           />
          
         </div>

           <div className="add-numbermain">
               <div className="tel-numbers">
                 {t("include_Transcript")}
                 <br />
                 <span className="phrecording text-secondary">
                   {t("vmail_copy_trans_text")}
                 </span>
               </div>
               <div className="d-flex">
                 <div className="phoneselect">
                   <div className="phoneselect">
                     <label className="switch">
                       <input
                         className="form-control"
                         {...register("voice_mail.email_transcript")}
                         type="checkbox"
                       />
                       <span className="slider round"></span>
                     </label>
                   </div>
                 </div>
               </div>
             </div>
         <div className="add-numbermain">
           <div className="tel-numbers">
             {t("email_notif")}
             <br />
           </div>
           <div className="d-flex">
             <div className="phoneselect">
               <div className="phoneselect">
                 <label className="switch">
                   <input
                     className="form-control"
                     id="hgemailnotify"
                     checked={watch("voice_mail.email_notify")}
                     type="checkbox"
                     onChange={(e) => {
                       e.stopPropagation();
                       e.preventDefault();
                       setValue("voice_mail.email_notify", e.target.checked, {
                         shouldDirty: true,
                       });
                       if (!e.target.checked) {
                         setValue("voice_mail.email_address", voicemailEAddress, { shouldDirty: true });
                       }
                       // clear error of email_notify
                       clearErrors("voice_mail.email_address");
 
                       // setValue("voice_mail.email_notify", e.target.value === 'on' ? true : false, {shouldDirty: true})
                       // setEnableEmails((obj) => !obj);
                       // handleToggleFunc();
                     }}
                   />
                   <span className="slider round"></span>
                 </label>
                   {errors.voice_mail?.email_notify && (
                    <p className="text-danger">
                      {errors.voice_mail?.email_notify?.message}
                    </p>
                  )}
               </div>
             </div>
           </div>
         </div>
         {watch("voice_mail.email_notify") && (
           <>
             <div className="add-numbermain">
               <div className="tel-numbers">
                 {t("email_address")} <br />
                 <span className="phrecording text-secondary">
                   {t("vmail_copy_email_text")}
                 </span>
               </div>
               <div className="d-flex w-30">
                 <div className="phoneselect w-100">
                   <input
                     {...register("voice_mail.email_address")}
                     placeholder="Enter Email Address"
                     className="w-100 form-control"
                   />
                   {errors.voice_mail?.email_address && (
                     <p className="text-danger">
                       {errors.voice_mail?.email_address.message}
                     </p>
                   )}
                 </div>
               </div>
             </div>
             <div className="add-numbermain">
               <div className="tel-numbers">
                 {t("del_send_message")}
                 <br />
               </div>
               <div className="d-flex">
                 <div className="phoneselect">
                   <div className="phoneselect">
                     <label className="switch">
                       <input
                         className="form-control"
                         type="checkbox"
                         {...register("voice_mail.vm_delete")}
                       />
                       <span className="slider round"></span>
                     </label>
                   </div>
                 </div>
               </div>
             </div>
           
             {/* <div className="add-numbermain">
               <div className="tel-numbers">
                 {t("email_copy_to_all_mem")}
                 <br />
               </div>
               <div className="d-flex">
                 <div className="phoneselect">
                   <div className="phoneselect">
                     <label className="switch">
                       <input
                         className="form-control"
                         {...register("voice_mail.email_to_members")}
                         type="checkbox"
                       />
                       <span className="slider round"></span>
                     </label>
                   </div>
                 </div>
               </div>
             </div> */}
             {/* <div className="add-numbermain">
               <div className="tel-numbers">
                 {t("email_copy_to_all_sup")}
                 <br />
               </div>
               <div className="d-flex">
                 <div className="phoneselect">
                   <div className="phoneselect">
                     <label className="switch">
                       <input
                         className="form-control"
                         {...register("voice_mail.email_to_sup")}
                         type="checkbox"
                       />
                       <span className="slider round"></span>
                     </label>
                   </div>
                 </div>
               </div>
             </div> */}
           </>
         )}
       </div>
 
       {unavailGreeting && (
         <PopupLoader
           title={t("VoiceMailunavaliableGreeting")}
           content={
             <Greeting
               module="Role"
               greetingType={1}
               uniqueId={aagcode}
               onClose={vmGreetingEnable}
             />
           }
           onShow={setUnavailGreeting}
           onClose={vmGreetingEnable}
         />
       )}
     </>
   );
 };
export default AAVoicemails
